<template>

  <body>
    <div class="modalContainer active loginModal formsModal">
      <div class="actualModal">
        <a href="#" class="closeModal"><i class="fal fa-times"></i></a>
        <div class="modalBodyOfItem">
          <div class="itemBodyLeftModal">
            <h4>Cancel Setup?</h4>
            <p class="formPara">
              Would you like to cancel your account setup? You can still
              continue your setup under your account settings.
            </p>
            <div class="quickCheckout dualBtnCheckout">
              <a href="#">Continue Set Up</a>
              <a href="#" class="oddBtn">Cancel Setup</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </body>
</template>
<script>
    export default {
        name: 'SignUp',
        data() {
            return {
                name: '',
                email: '',
                password: '',
                token: this.$route.query.token
            }
        },
        methods: {
            handleSubmit(e) {
                console.log('form submitted')
                this.submitted = true
                const {
                    name,
                    email,
                    password,
                    phone,
                    token
                } = this
                const {
                    dispatch
                } = this.$store
                if (email && password) {
                    dispatch('auth/register', {
                        name,
                        email,
                        password,
                        phone,
                        token
                    })
                }
            }
        },
        watch: {
            '$route'(to, from) {
                // react to route changes...
                this.token = this.$route.query.token
            }
        }

    }
</script>
<style>
    .sign-up-page-wrapper {
        padding: 5px;
    }
</style>
